<template>
  <svg
    width="19"
    height="20"
    viewBox="0 0 19 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.75 18.3073C1.88312 18.3913 2.836 17.4375 3.66638 17.4375C4.49675 17.4375 5.84687 18.3169 6.58362 18.3073C7.46737 18.3151 8.5025 17.4375 9.5 17.4375C10.4975 17.4375 11.5326 18.3151 12.4164 18.3073C13.5495 18.3913 14.5024 17.4375 15.3336 17.4375C16.1649 17.4375 17.5132 18.3169 18.25 18.3073M4.25 17.4375C3.00925 15.8923 2.13513 13.9139 1.76238 12.8656C1.64425 12.5331 1.58562 12.3669 1.65387 12.2076C1.723 12.0493 1.89012 11.9749 2.227 11.8261L8.78075 8.92288C9.13425 8.76538 9.31187 8.6875 9.5 8.6875C9.68813 8.6875 9.86575 8.76625 10.2201 8.92375L16.773 11.8261C17.109 11.9749 17.277 12.0493 17.3461 12.2076C17.4144 12.3669 17.3549 12.5331 17.2376 12.8656C16.8649 13.9139 15.9907 15.8923 14.75 17.4375"
      stroke="#213E7A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.25 10.875L4.439 8.41887C4.55713 6.88587 4.61575 6.11937 5.11888 5.65387C5.622 5.1875 6.39113 5.1875 7.9285 5.1875H11.0715C12.6089 5.1875 13.378 5.1875 13.8803 5.65387C14.3843 6.11937 14.4429 6.88587 14.561 8.41887L14.75 10.875"
      stroke="#213E7A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.4375 5.1875L6.588 3.987C6.7245 2.89237 6.79275 2.34462 7.1655 2.01562C7.53737 1.6875 8.08862 1.6875 9.192 1.6875H9.808C10.9105 1.6875 11.4626 1.6875 11.8345 2.01562C12.2073 2.34462 12.2755 2.89237 12.412 3.987L12.5625 5.1875"
      stroke="#213E7A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "ExportShipmentIcon",
};
</script>

<style></style>
